export default "__VITE_ASSET__DJbOivCM__"